import { ReactNode, CSSProperties } from "react";
import {
    healthChildSectionY,
    healthChildSectionYDense,
    healthChildSectionYTight,
    healthContentPadX,
    healthSectionInnerStyle,
    healthSectionOuter,
    healthSectionY,
    healthSectionYCompact,
} from "./healthLayout";

interface HealthSectionProps {
    id?: string;
    ariaLabelledBy?: string;
    children: ReactNode;
    className?: string;
    compact?: boolean;
    tight?: boolean;
    /** Module-detail pages under /health (e.g. Aimma Doctor) — tighter vertical rhythm */
    childPage?: boolean;
    /** Tighter child-page sections (e.g. FAQ) */
    childTight?: boolean;
    /** Denser child-page rhythm (Aimma Doctor layout polish) */
    childPageDense?: boolean;
    /** No vertical section padding (e.g. lifecycle scroll track bleeds to band edges) */
    flushY?: boolean;
    /** Override default section inner max-width (e.g. wider showcase sections). */
    innerStyle?: CSSProperties;
    style?: CSSProperties;
}

export function HealthSection({
    id,
    ariaLabelledBy,
    children,
    className = "",
    compact,
    tight,
    childPage,
    childTight,
    childPageDense,
    flushY,
    innerStyle,
    style,
}: HealthSectionProps) {
    const py = flushY
        ? "py-0"
        : childTight
        ? healthChildSectionYTight
        : childPageDense
          ? healthChildSectionYDense
          : childPage
            ? healthChildSectionY
            : tight
            ? healthSectionYCompact
            : compact
              ? healthSectionYCompact
              : healthSectionY;

    return (
        <section
            id={id}
            aria-labelledby={ariaLabelledBy}
            className={`${healthSectionOuter} ${className}`}
            style={style}
        >
            <div className="m-auto w-full" style={innerStyle ?? healthSectionInnerStyle}>
                <div className={`${healthContentPadX} ${py} text-left`}>{children}</div>
            </div>
        </section>
    );
}
